import { defineStore } from 'pinia'
import { useAnnotationsStore } from 'Store/pages/imageReview/annotationsStore'
import { useImagesStore } from 'Store/pages/imageReview/imagesStore'
import { useInterfaceStore } from 'Store/pages/imageReview/interfaceStore'
import { useServerStore } from 'Store/pages/imageReview/serverStore'
import { useMeasurementStore } from 'Store/pages/imageReview/measurementsStore'

export const useImageReviewStore = defineStore('ImageReview', () => {
  const annotationsStore = useAnnotationsStore()
  const interfaceStore = useInterfaceStore()
  const imagesStore = useImagesStore()
  const serverStore = useServerStore()
  const measurementsStore = useMeasurementStore()

  return {
    annotationsStore,
    interfaceStore,
    imagesStore,
    serverStore,
    measurementsStore,
  }
})
